import Cookies from "js-cookie";

const TokenKey = "Admin-Token";

const UserId = "User-Id"; // 登陆ID

const LoginStatus = "Login-Status";

const LoginOk = 0; // 0标识成功

const ProjectId = "Project-Id"; // 项目ID标识

const ProName = "Pro-Name"; // 项目名称

const ProNo = "Pro-No"; // 项目编号

const Info = "Info"; // 个人信息 (0是平台，1是项目内)

const Blind = "Blind"; // 双盲，单盲， 开放

const Random = "Random"; // 随机类型（动态、静态）

const Section = "Section"; // 区段（分配、竞争）

const Front = "Front"; // 筛选号是否系统生成

const After = "After"; // 随机号是否系统生成

const ProStatus = "ProStatus"; // 项目状态（创建中、进行中、锁定）

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function setUserId(id) {
  return Cookies.set(UserId, id);
}

export function getUserId() {
  return Cookies.get(UserId);
}

export function removeUserId() {
  return Cookies.remove(UserId);
}

export function setProInfo(res) {
  return sessionStorage.setItem("iwrs_project", JSON.stringify(res));
}

export function getProDetail() {
  return JSON.parse(sessionStorage.getItem("iwrs_project"));
}

export function setLoginStatus() {
  return sessionStorage.setItem(LoginStatus, LoginOk);
}

export function getLoginStatus() {
  return sessionStorage.getItem(LoginStatus);
}

export function removeLoginStatus() {
  return sessionStorage.removeItem(LoginStatus);
}
export function getProjectId() {
  return sessionStorage.getItem(ProjectId);
}

export function setProjectId(id) {
  return sessionStorage.setItem(ProjectId, id);
}

export function removeProjectId() {
  return sessionStorage.removeItem(ProjectId);
}

export function getProName() {
  return sessionStorage.getItem(ProName);
}

export function setProName(val) {
  return sessionStorage.setItem(ProName, val);
}

export function removeProName() {
  return sessionStorage.removeItem(ProName);
}

export function getProNo() {
  return sessionStorage.getItem(ProNo);
}

export function setProNo(val) {
  return sessionStorage.setItem(ProNo, val);
}

export function removeProNo() {
  return sessionStorage.removeItem(ProNo);
}

export function setInfo(val) {
  return sessionStorage.setItem(Info, val);
}

export function getInfo() {
  return sessionStorage.getItem(Info);
}

export function removeInfo() {
  return sessionStorage.removeItem(Info);
}

export function getBlind() {
  return sessionStorage.getItem(Blind);
}

export function setBlind(val) {
  return sessionStorage.setItem(Blind, val);
}

export function removeBlind() {
  return sessionStorage.removeItem(Blind);
}

export function getRandom() {
  return sessionStorage.getItem(Random);
}

export function setRandom(val) {
  return sessionStorage.setItem(Random, val);
}

export function removeRandom() {
  return sessionStorage.removeItem(Random);
}

export function getSection() {
  return sessionStorage.getItem(Section);
}

export function setSection(val) {
  return sessionStorage.setItem(Section, val);
}

export function removeSection() {
  return sessionStorage.removeItem(Section);
}

export function getFront() {
  return sessionStorage.getItem(Front);
}

export function setFront(val) {
  return sessionStorage.setItem(Front, val);
}

export function removeFront() {
  return sessionStorage.removeItem(Front);
}

export function getAfter() {
  return sessionStorage.getItem(After);
}

export function setAfter(val) {
  return sessionStorage.setItem(After, val);
}

export function removeAfter() {
  return sessionStorage.removeItem(After);
}

export function getProStatus() {
  return sessionStorage.getItem(ProStatus);
}

export function setProStatus(val) {
  return sessionStorage.setItem(ProStatus, val);
}

export function removeProStatus() {
  return sessionStorage.removeItem(ProStatus);
}
